import React, { useEffect, useRef } from "react";
import { MapProxy } from "../../../components/map/map-proxy.tsx";
import type { MapHandle } from "../../../components/map/map-client.tsx";

interface PropertyMapProps {
  lat: number;
  lon: number;
  displayAddress: string;
  containerClass?: string;
  isTabActive?: boolean;
}

export const PropertyMap: React.FC<PropertyMapProps> = ({
  isTabActive,
  lat,
  lon,
  displayAddress,
  containerClass = "h-full w-full",
}) => {
  const markers = [
    {
      location: { lat: lat, lon: lon },
      markerType: "home" as const,
      popup: {
        infoItems: [{ icon: "fa-sharp fa-solid fa-house-chimney", text: displayAddress }],
      },
    },
  ];
  const mapRef = useRef<MapHandle>(null);
  useEffect(() => {
    if (isTabActive) {
      mapRef.current?.refreshMap();
    }
  }, [isTabActive]);

  return <MapProxy ref={mapRef} containerClass={containerClass} markers={markers} />;
};
